import { content } from "@/i18n/content";
import { useLang } from "@/i18n/language";
import { Section, SectionHeading } from "./Primitives";

export function Included() {
  const { lang } = useLang();
  const t = content[lang];

  return (
    <Section id="included" tone="light">
      <SectionHeading eyebrow={t.included.eyebrow} title={t.included.title} lead={t.included.lead} tone="light" />

      <div className="mt-12 grid gap-px overflow-hidden rounded-xl bg-cream-foreground/10 sm:grid-cols-2 lg:grid-cols-3">
        {t.included.items.map((item, i) => (
          <div key={item.title} className="bg-cream p-7">
            <span className="text-xs font-semibold tracking-widest text-primary">
              {String(i + 1).padStart(2, "0")}
            </span>
            <h3 className="mt-3 text-lg font-semibold">{item.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-cream-foreground/70">{item.body}</p>
          </div>
        ))}
      </div>

      <div className="mt-20 border-t border-cream-foreground/10 pt-14">
        <SectionHeading eyebrow={t.global.eyebrow} title={t.global.title} lead={t.global.lead} tone="light" />
        <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {t.global.items.map((item) => (
            <div key={item.title} className="border-t border-primary/40 pt-5">
              <h3 className="text-base font-semibold">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-cream-foreground/70">{item.body}</p>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}
